
  import { mapState, mapActions } from 'vuex'

  export default {
    data() {
      return {
        showQuantityPopup: false,
      }
    },
    props: {
      item: {
        type: Object,
        default: () => {}
      }
    },
    computed: {
      ...mapState(['menu', 'order', 'channel', 'location']),
      isCatering() {
        return (
          this.channel === 'catering' || window.location.href.includes('catering')
        )
      },
      image() {
        let image = 'https://storyblok.pleinaircdn.com/f/110020/62x62/7e05138e6f/placeholder.svg'
        if (this.menu) {
          this.menu.categories.forEach(category => {
            category.products.forEach(menuItem => {
              if (menuItem.name == this.item.name) {
                const imageSource = menuItem.images?.[1]?.filename
                if (imageSource) {
                  if (process.env.GW_ENV === 'stage' || process.env.GW_ENV === 'prod') {
                    image = `https://olo-images-live.imgix.net/${imageSource}`
                  } else {
                    image = `https://olo-images-sandbox.imgix.net/${imageSource}`
                  }
                }
              }
            })
          })
        }
        return image
      },
      description() {
        if (this.item.choices && this.item.choices.length) {
          let desc = this.item.choices[0].name
          if (this.item.choices[0].quantity > 1) {
            desc = desc+' (x'+this.item.choices[0].quantity+')'
          }
          if (this.item.choices) {
            this.item.choices.forEach((choice, i) => {
              if (i > 0) {
                desc = desc+', '+choice.name
                if (choice.quantity > 1) {
                  desc = desc+' (x'+choice.quantity+')'
                }
              }
            })
          }
          if (this.item.instructions) {
            desc = desc+' ('+this.item.instructions+')'
          }
          return desc
        }
      },
    },
    methods: {
      ...mapActions([
        'decreaseQuantity',
        'increaseQuantity',
      ]),
      getEventData(item) {
        const eventItem = {
          'item_id': item.id,
          'item_name': item.name,
          'price': item.cost.total,
          'quantity': item.quantity,
        }

        const category = this.menu.categories.find(c => c.products.find(p => p.name === eventItem.item_name))
        if (category) {
          eventItem.item_list_id = category.id
          eventItem.item_list_name = category.name
          eventItem.item_category = category.name
        }

        return {
          'ecommerce': {
            'affiliation': this.channel,
            'items': [eventItem],
            'currency': 'USD',
            'item_list_id': eventItem.item_list_id,
            'item_list_name': eventItem.item_list_name,
            'item_category': eventItem.item_category,
            'location_name': this.location?.name,
            'location_code': this.location?.id,
            'price':  eventItem.price,
          }
        }
      },
      getBeginCheckoutEventData() {
        const eventItems = this.order.products.map((item, index) => {
          const category = this.menu.categories.find(c => c.products.find(p => p.name === item.name))
          const itemData = {
            'index': index,
            'item_id': item.id,
            'item_name': item.name,
            'price': item.cost.total,
            'quantity': item.quantity,
          }

          if (category) {
            itemData.item_list_id = category.id
            itemData.item_list_name = category.name
            itemData.item_category = category.name
          }

          return itemData
        })

        const orderType = this.order?.handoff == 'dispatch' ? 'delivery' : this.order?.handoff || ''

        return {
          'ecommerce': {
            'affiliation': this.channel,
            'items': eventItems,
            'currency': 'USD',
            'location_name': this.location?.name,
            'location_code': this.location?.id,
            'order_type': orderType,
            'price':  this.order.totals.subtotal,
          }
        }
      },
      async add(item) {
        // Get full product data from menu
        let product = null
        if (this.menu) {
          this.menu.categories.forEach(category => {
            category.products.forEach(menuItem => {
              if (menuItem.name === item.name) {
                product = menuItem
              }
            })
          })
        }

        // Limit quantity if set
        if (product.limit_quantity) {
          if (parseInt(item.quantity) === parseInt(product.limit_quantity)) {
            this.showQuantityPopup = true
            return
          }
        }

        const route = this.$route
        await this.increaseQuantity({ item, route })

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          'event': 'add_to_cart',
          ...this.getEventData(this.item)
        })

        if (this.$route.name === 'order-checkout') {
          window.dataLayer.push({
            'event': 'begin_checkout',
            ...this.getBeginCheckoutEventData()
          });
        }

        const orderType = this.isCatering ? 'Catering' : 'Mealtime'
        this.$braze.logCustomEvent('Add_Product_To_Cart', {
          Product: this.item,
          Cart_Items: this.order.products,
          Cart_Cost: this.order.totals.total,
          Channel: orderType
        })
      },

      async remove() {
        await this.$api.removeFromOrder(this.item.id)
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          'event': 'remove_from_cart',
          ...this.getEventData(this.item)
        })
        if (this.order.products.length > 0) {
          await this.$api.validateOrder()
        } else {
          this.$router.push('/order/')
          this.removePromo();
        }
      },
      edit() {
        let link = {}
        this.menu.categories.map((c) => {
          c.products.map((r) => {
            if (this.item.product_id === r.id) {
              link = {
                path: '/order/product',
                query: {
                  id: r.sku,
                  cid: this.item.id,
                  q: this.item.quantity
                }
              }
            }
          })
        })
        this.$router.push(link)
        if (this.$route.name == 'order-product') {
          setTimeout(() => {
            this.$router.go(link)
          },250)
        }
        this.$store.commit('setShowCart', false)
      },

      async decreaseQuantityItem(item) {
        if (item) {
          await this.decreaseQuantity(item)

          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            'event': 'remove_from_cart',
            ...this.getEventData(this.item)
          })

          if (this.order &&  this.order.totals.total < 200) {
            this.removePromo()
          }
        }
      },

      async removePromo() {
        if (this.order && this.order?.coupon) {
          await this.$api.removeCoupon()
        }
      },
    }
  }
